@if (displayToast()) {
  <div
    [class]="
      'thrivable-shadow fixed top-auto right-5 bottom-5 left-auto z-[100] max-w-[400px] rounded-xl bg-white p-4 text-sm shadow-lg transition-opacity duration-300 xl:min-w-[400px] ' +
      opacityClass()
    ">
    <button (click)="toastService.hideNotification()" class="absolute top-4 right-4 ml-auto">
      <i class="fa-solid fa-xmark-large"></i>
    </button>

    <div class="flex space-x-4">
      @switch (toastInfo()!.toastClass) {
        @case ('SUCCESS') {
          <span class="fa-stack fa-xl">
            <i class="fas fa-circle fa-stack-2x text-success opacity-10"></i>
            <i class="fa-solid fa-circle-check fa-stack-1x text-success"></i>
          </span>
        }

        @case ('INFO') {
          <span class="fa-stack fa-xl">
            <i class="fas fa-circle fa-stack-2x text-info opacity-10"></i>
            <i class="fa-solid fa-circle-info fa-stack-1x text-info"></i>
          </span>
        }

        @case ('WARNING') {
          <span class="fa-stack fa-xl">
            <i class="fas fa-circle fa-stack-2x text-warning opacity-10"></i>
            <i class="fa-solid fa-triangle-exclamation fa-stack-1x text-warning"></i>
          </span>
        }

        @case ('ERROR') {
          <span class="fa-stack fa-xl">
            <i class="fas fa-circle fa-stack-2x text-error opacity-10"></i>
            <i class="fa-solid fa-circle-xmark fa-stack-1x text-error"></i>
          </span>
        }
      }

      <div class="flex-1">
        @switch (toastInfo()!.toastClass) {
          @case ('SUCCESS') {
            <p class="text-success pr-6 text-base font-semibold" i18n>Success</p>
          }
          @case ('INFO') {
            <p class="text-info pr-6 text-base font-semibold" i18n>Info</p>
          }
          @case ('WARNING') {
            <p class="shadow-sm-2xsl text-warning pr-6 text-base font-semibold" i18n>Warning</p>
          }
          @case ('ERROR') {
            <p class="text-error pr-6 text-base font-semibold" i18n>Error</p>
          }
        }

        <div class="mt-1 text-gray-600">
          @if (isString()) {
            <span>{{ toastInfo()!.message }}</span>
          } @else {
            <ng-template [ngTemplateOutlet]="template()" />
          }
        </div>

        <div class="mt-2 flex space-x-4">
          <button
            class="text-primary hover:text-secondary inline-block leading-loose font-medium transition-colors duration-100"
            (click)="toastService.hideNotification()"
            i18n>
            Dismiss
          </button>
        </div>
      </div>
    </div>
  </div>
}
